<template>
  <v-switch
      class="switch-theme"
      inset
      dense
      color="var(--theme-color-three)"
      :true-value="trueValue"
      :false-value="falseValue"
      :input-value="inputValue"
      @change="eventChange"
  ></v-switch>
</template>

<script>
export default {
  name: "SwitchInset",
  props: {
    inputValue: {
      default: false // this is value/v-model
    },
    trueValue: {
      default: 1
    },
    falseValue: {
      default: 0
    }
  },
  methods: {
    eventChange (val) {
      this.$emit('onChange', val)
    }
  }
}
</script>

<style scoped>

</style>
